<!-- <div *ngIf="isLoading" class="flex justify-center items-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div> -->



<!-- <div class="container mx-auto px-4 py-10">
  <div *ngIf="!isLoading && handhole" class="bg-white rounded-md">
    <p-card>
      <div class="p-7 w-full">
        <ng-template pTemplate="header">
          <h2 class="text-2xl font-bold">Fiber Details</h2>
        </ng-template>

        <div class="mb-4">
          <strong>Size:</strong> <span>{{ handhole.size }}</span>
        </div>
        <div class="mb-4">
          <strong>Status:</strong> <span>{{ handhole.status }}</span>
        </div>
        <div class="mb-4">
          <strong>Coordinates:</strong> <span>{{ handhole.overlay_data }}</span>
        </div>
        <div class="mb-4">
          <strong>4x4:</strong> <span>{{ handhole.is_4x4 ? 'Yes' : 'No' }}</span>
        </div>
        <div class="mb-4">
          <strong>VDOT:</strong> <span>{{ handhole.is_vdot ? 'Yes' : 'No' }}</span>
        </div>

        <ng-template pTemplate="footer">
          <button
          pButton
          label="Back to List"
          icon="pi pi-arrow-left"
          class="p-button-secondary"
          routerLink="/conduit/list"
        ></button>
        </ng-template>
      </div>
    </p-card>
  </div>
</div> -->
<div class="container mx-auto py-10 px-6">
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-semibold text-gray-800">Order Overview</h1>
    <p class="text-sm text-gray-500">View all of Your Clients Information</p>
  </div>

  <!-- Order Details Grid -->
  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
    <!-- Service Details -->
    <p-card>
      <div class="flex w-full items-start justify-between">
        <div class="text-gray-700">
          <h2 class="font-semibold text-lg mb-1">Service Details</h2>
          <p class="text-sm text-gray-500">Worem Ipsum</p>
          <p class="text-xs text-gray-400">
            Dorem Ipsum is simply dummy text of the
          </p>
        </div>
        <p-button variant="text">
          <img src="/list/1.png" alt="list" class="w-[36px] h-[36px]" />
        </p-button>
      </div>
    </p-card>
    <p-card>
      <div class="flex w-full items-start justify-between">
        <div class="text-gray-700">
          <h2 class="font-semibold text-lg mb-1">Billing Details</h2>
          <p class="text-sm text-gray-500">Worem Ipsum</p>
          <p class="text-xs text-gray-400">
            Dorem Ipsum is simply dummy text of the
          </p>
        </div>
        <p-button variant="text">
          <img src="/list/2.png" alt="list" class="w-[36px] h-[36px]" />
        </p-button>
      </div>
    </p-card>

    <p-card>
      <div class="flex w-full items-start justify-between">
        <div class="text-gray-700">
          <h2 class="font-semibold text-lg mb-1">Payment Details</h2>
          <p class="text-sm text-gray-500">Worem Ipsum</p>
          <p class="text-xs text-gray-400">
            Dorem Ipsum is simply dummy text of the
          </p>
        </div>
        <p-button variant="text">
          <img src="/list/3.png" alt="list" class="w-[36px] h-[36px]" />
        </p-button>
      </div>
    </p-card>
    <p-card>
      <div class="flex w-full items-start justify-between">
        <div class="text-gray-700">
          <h2 class="font-semibold text-lg mb-1">Customer Info</h2>
          <p class="text-sm text-gray-500">Worem Ipsum</p>
          <p class="text-xs text-gray-400">
            Dorem Ipsum is simply dummy text of the
          </p>
        </div>
        <p-button variant="text">
          <img src="/list/4.png" alt="list" class="w-[36px] h-[36px]" />
        </p-button>
      </div>
    </p-card>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-12">
    <div class="col-span-9">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mt-6">
        <!-- Order ID -->
        <p-card>
          <h2 class="text-lg font-semibold text-gray-800">#TWT501</h2>
          <p class="text-xs text-gray-500">Order ID</p>
        </p-card>

        <!-- Order Date -->
        <p-card>
          <h2 class="text-lg font-semibold text-gray-800">02 Jan, 2025</h2>
          <p class="text-xs text-gray-500">Order Date</p>
        </p-card>

        <!-- Delivery Date -->
        <p-card>
          <h2 class="text-lg font-semibold text-gray-800">09 Jan, 2025</h2>
          <p class="text-xs text-gray-500">Delivery Date</p>
        </p-card>

        <!-- Order Amount -->
        <p-card>
          <h2 class="text-lg font-semibold text-gray-800">$120.49</h2>
          <p class="text-xs text-gray-500">Order Amount</p>
        </p-card>

        <!-- Order Status -->
        <p-card>
          <h2 class="text-lg font-semibold text-gray-800">Delivery</h2>
          <p class="text-xs text-gray-500">Order Status</p>
        </p-card>
      </div>
    </div>
    <div class="col-span-3 px-4 mt-5">
      <!-- Documents -->
      <div class="bg-white shadow-sm p-4 rounded-lg col-span-2">
        <h2 class="text-lg font-semibold text-gray-800">Documents</h2>
        <p class="text-xs text-gray-500">
          Invoice No:
          <a href="#" class="text-blue-500 hover:underline">TWT501</a>
        </p>
        <p class="text-xs text-gray-500">
          Delivery No:
          <a href="#" class="text-blue-500 hover:underline">TWT501</a>
        </p>
      </div>
    </div>
  </div>

  <!-- Order Summary Section -->
  <div class="grid grid-cols-12">
    <div class="col-span-9 bg-white shadow-md rounded-lg p-6 mt-6">
      <h2 class="font-semibold text-lg text-gray-700 mb-4">Order Summary</h2>

      <!-- Table -->
      <p-table [value]="orderItems" class="w-full">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left">Product</th>
            <th class="text-left">Price</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td class="flex items-center gap-2">
             <img src="/list/5.png" alt="">
              <div>
                <p class="text-sm text-gray-800">{{ item.name }}</p>
                <p class="text-xs text-gray-500">{{ item.size }}</p>
              </div>
            </td>
            <td class="text-gray-700">${{ item.price }}</td>
          </tr>
        </ng-template>
      </p-table>
      <div
      class="mt-4 text-gray-700  p-6 "
    >
      <p class="flex justify-between">
        <span>Sub Total</span>
        <span>$380.98</span>
      </p>
      <p class="flex justify-between">
        <span>Estimated Tax (18%)</span>
        <span>$380.98</span>
      </p>
      <p class="flex justify-between">
        <span>Item Discounts (-$25)</span>
        <span>$0.00</span>
      </p>
      <p class="flex justify-between font-semibold text-lg">
        <span>Total Amount (USD)</span>
        <span>$380.98</span>
      </p>
    </div>
    </div>

    <div class="col-span-3 px-4 mt-4">
      <p-card>
        <div class="text-gray-700">
          <h2 class="text-lg font-semibold text-gray-900">Logistics Details</h2>
          <p class="text-sm text-gray-600">Express Delivery</p>
          <p class="text-xs text-gray-500">
            ID: <span class="text-gray-700 font-medium">EDTW1400457854</span>
          </p>
        </div>
      </p-card>
    </div>

  </div>
</div>
